import { translate } from "@/i18n/translate";

export function formatDailyCounter(
  value: number | string | null | undefined,
): string {
  if (value === null || value === undefined) {
    return translate("common.notAvailable");
  }

  const counter = String(value).trim();
  if (!counter) {
    return translate("common.notAvailable");
  }

  return counter.startsWith("#") ? counter : `#${counter}`;
}

export function formatCaptureCount(
  value: number | null | undefined,
  fallback = "0",
): string {
  return value === null || value === undefined ? fallback : String(value);
}
